import { createApp } from 'vue';
import App from './app/App.vue';
import store from './app/store';
import router from './app/router';

global.formatDate = (date) => {
  var options = {
    weekday: 'long',
    year: 'numeric',
    month: 'long',
    day: 'numeric',
  }
  var dateStr = new Date(date)
  return dateStr.toLocaleDateString('en-US', options)
}

global.showError = (msg, relogin) => {
  window.alert(msg)
  if (relogin) router.push('/')
}

global.readCookie = (name) => {
  var nameEQ = name + '='
  //console.log(name +" - " + document.cookie);
  var ca = document.cookie.split(';')
  for (var i = 0; i < ca.length; i++) {
    var c = ca[i]
    while (c.charAt(0) === ' ') {
      c = c.substring(1, c.length)
    }
    if (c.indexOf(nameEQ) === 0) {
      return c.substring(nameEQ.length, c.length)
    }
  }
  return false
}
if ('serviceWorker' in navigator) {
  window.addEventListener('load', function () {
    //navigator.serviceWorker.register('/service-worker.js')
    navigator.serviceWorker.getRegistrations().then( 
      function(registrations) { 
        for (let registration of registrations) {
          registration.unregister();
        } 
      }
    );
  })
}
createApp(App).use(store).use(router).mount('#app')
